<script>
import { watch } from 'vue';
import { inicializarServicioDeListado, listarUbicacionesDePuntoDeVenta, desconectarServicioDeListado } from '@/../../cliente_comun/fuentes_puntosDeVenta_ubicaciones.js'

const encabezado = [
	{ text: 'Nombre', value: 'nombre', sortable: false },
	{ text: 'Descripción', value: 'descripción', sortable: false },
	{ text: '', value: 'acciones', align: 'end', filterable: false, sortable: false },
]

export default {
	props: {
		identificadorDePuntoDeVenta: String
	},
	beforeDestroy() {
		desconectarServicioDeListado()
	},
	setup(props, { emit }) {
		const servicioDeListado = inicializarServicioDeListado(props.identificadorDePuntoDeVenta)

		watch(() => props.identificadorDePuntoDeVenta, () => {
			if (props.identificadorDePuntoDeVenta) {
				listarUbicacionesDePuntoDeVenta(props.identificadorDePuntoDeVenta)
			}
		})

		return {
			emit,
			servicioDeListado,
			encabezado,
		}
	}
}

</script>

<template>
	<v-data-table
		:headers="encabezado"
		:items="servicioDeListado.listado.value"
		item-key="identificador"
		class="elevation-1 mb-16"
		:items-per-page="10000"
		:loading="servicioDeListado.listando.value"
		hide-default-footer
	>
		<template v-slot:item.nombre="{ item }">
			{{ item.nombre }}
		</template>
		<template v-slot:item.acciones="{ item }">
			<v-tooltip bottom>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-on="on" v-bind="attrs" @click="emit('editar', item)">
						<v-icon>mdi-pencil</v-icon>
					</v-btn>
				</template>
				<span>Editar ubicación</span>
			</v-tooltip>
		</template>
	</v-data-table>
</template>
